import refs from './refs';

export default function () {
  refs.switchToTodayBtn.dataset.rendered = false;
  refs.switchToFiveDaysBtn.dataset.rendered = false;
}
